// Native bridge shim — implementations duplicated from mobile/src/native-bridge.ts
// (CRA's ModuleScopePlugin forbids re-exporting from outside src/)
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import { Share } from '@capacitor/share';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

async function openCognitoOAuth(cognitoHostedUiUrl: string, onCallback: (url: string) => void) {
  const appUrlListener = await App.addListener('appUrlOpen', (event) => {
    if (event.url.startsWith('makeyourkidshero://auth/callback')) {
      appUrlListener.remove();
      browserListener.remove();
      onCallback(event.url);
    }
  });

  const browserListener = await Browser.addListener('browserFinished', () => {
    appUrlListener.remove();
    browserListener.remove();
    onCallback('');
  });

  await Browser.open({ url: cognitoHostedUiUrl, windowName: '_self', presentationStyle: 'popover' });
}

export async function loginWithGoogleNative() {
  if (!Capacitor.isNativePlatform()) return null;
  await GoogleAuth.initialize();
  const result = await GoogleAuth.signIn();
  return {
    idToken: result.authentication.idToken,
    email: result.email,
    name: result.name,
    imageUrl: result.imageUrl,
  };
}

export async function loginWithGoogle(cognitoHostedUiUrl: string, onCallback: (url: string) => void) {
  if (!Capacitor.isNativePlatform()) return;
  await openCognitoOAuth(cognitoHostedUiUrl, onCallback);
}

export async function loginWithApple(cognitoHostedUiUrl: string, onCallback: (url: string) => void) {
  if (!Capacitor.isNativePlatform()) return;
  await openCognitoOAuth(cognitoHostedUiUrl, onCallback);
}

export async function loginWithFacebook(cognitoHostedUiUrl: string, onCallback: (url: string) => void) {
  if (!Capacitor.isNativePlatform()) return;
  await openCognitoOAuth(cognitoHostedUiUrl, onCallback);
}

export async function shareStoryNative(options: { title: string; text: string; url: string }) {
  if (Capacitor.isNativePlatform()) {
    await Share.share({
      title: options.title,
      text: options.text,
      url: options.url,
      dialogTitle: 'Share this story',
    });
  }
}

// no-op in web bundle — real implementation lives in mobile/src/native-bridge.ts
export async function maybeRequestReview() {}

export function setupDeeplinks() {
  if (!Capacitor.isNativePlatform()) return;

  App.addListener('appUrlOpen', (event) => {
    try {
      const url = new URL(event.url);
      // Handle shared story deep links: https://makeyourkidshero.com/stories/shared/{token}
      // or custom scheme: makeyourkidshero://stories/shared/{token}
      const match = url.pathname.match(/\/stories\/shared\/([^/?]+)/);
      if (match) {
        window.location.href = `/stories/shared/${match[1]}`;
      }
    } catch (err) {
      console.warn('[deeplink] Failed to parse URL:', event.url);
    }
  });
}
